export default {
  _not_interested_in_this_video: '%second% لست مهتمًا بهذا الفيديو؟',
  _switch_one: 'آخر',
}